import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google'
import { useNavigate } from 'react-router-dom';
import './App.css';
import { createSocialAccount, getGeneralSettings } from './helper/apiHelper.js'
import logo from './assets/images/logo.png';
import { social_svg } from './assets/social_svg/svg.js'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { clearStorage } from './helper/commonHelper.js'
import { config } from './helper/configVariable.js';
import { getBrowserDetails } from './helper/commonHelper.js';
import { toast, Bounce } from 'react-toastify';
import { useLoading } from './context/LoadingContext';


function App() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { showLoader, hideLoader } = useLoading();

  const history = useNavigate();
  const login = useGoogleLogin({
    onSuccess: async tokenResponse => {
      try {
        const userInfo = await fetch('https://www.googleapis.com/userinfo/v2/me', {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`, // Corrected template literal
          },
        });
        const userData = await userInfo.json();

        const formData = {
          type: 'google',
          user: userData ?? null,
          key: userData.id,
          accessToken: tokenResponse.access_token,
          tokenExpiry: tokenResponse.expires_in,
          browser: await getBrowserDetails()
        };
        const apiResponse = await createSocialAccount(formData);

        if (apiResponse.error) {
          toast.error(apiResponse.error, { position: "top-center", transition: Bounce });
          return;
        }

        if (apiResponse.returnValue) {
          const data = {
            type: 'google',
            name: userData.name,
            email: userData.email,
            wallet: apiResponse.returnValue,
            profile_url: userData.picture
          };

          await clearStorage(); 
          localStorage.setItem('user', JSON.stringify(data));
          localStorage.setItem('access_token', apiResponse.returnValue.token);

          try {
              const response = await getGeneralSettings();
              if (response && response.time_zone) {
                  localStorage.setItem('timeZone', response.time_zone);
              } else {
                  console.warn("Could not retrieve time zone from general settings.");
              }
          } catch (settingsError) {
              console.error("Error fetching general settings:", settingsError);
              toast.error("Could not load user settings.", { position: "top-center", transition: Bounce });
          }


          if (apiResponse.returnValue.wallet.user_id) {
            history("/home");
          } else {
            history("/signup");
          }
        } else {
             toast.error("Login failed: Unexpected response from server.", { position: "top-center", transition: Bounce });
        }
      } catch (error) {
          console.error("Error processing Google login success:", error);
          toast.error("An error occurred after Google login.", { position: "top-center", transition: Bounce });
      } finally {
          hideLoader(); 
      }
    },
    onError: errorResponse => {
      try {
        localStorage.removeItem('user'); 
        let errorMessage = "Google login failed. Please try again.";
        console.log(errorResponse,"errorResponse?.error")
      if (errorResponse?.error) {
             errorMessage = `Google login error: ${errorResponse.error}`;
        }
        toast.error(errorMessage, { position: "top-center", transition: Bounce });
      } catch(e) {
         console.error("Error within onError handler:", e);
      } finally {
        hideLoader();
      }
    },
    onNonOAuthError: nonOAuthError => {
      console.log('Google Login Non-OAuth error:', nonOAuthError);
      toast.error(`Could not initiate Google login`, { position: "top-center", transition: Bounce });
      hideLoader(); // Hide loader if initiation fails
  }
  });

  const handleFacebookCallback = async (response) => {
    try{
    if (response?.status === "unknown") {
      console.error('Sorry!', 'Something went wrong with facebook Login.');
      return;
    }

    const form = {
      type: 'facebook',
      user: response ?? null,
      key: response.userID,
      accessToken: response.accessToken,
      tokenExpiry: response.expiresIn,
      browser: await getBrowserDetails()
    };
    const apiResponse = await createSocialAccount(form);
    if (apiResponse.error) {
      alert(apiResponse.error);
      return;
    }
    if (apiResponse.returnValue) {
      const data = {
        type: 'facebook',
        name: response.name,
        userID: response.userID,
        wallet: apiResponse.returnValue,
        profile_url: response.picture.data.url
      };
      if (apiResponse.returnValue.wallet.user_id) {
        await clearStorage();
        localStorage.setItem('user', JSON.stringify(data));
        localStorage.setItem('access_token', apiResponse.returnValue.token);
        const responseSettings = await getGeneralSettings();
        if (responseSettings) {
          localStorage.setItem('timeZone', responseSettings.time_zone);
        }
        history("/home");
      } else {
        await clearStorage();
        localStorage.setItem('user', JSON.stringify(data));
        localStorage.setItem('access_token', apiResponse.returnValue.token);
        history("/signup");
      }
    }}
    catch(error){
       console.error(error)
    }
    finally{
       hideLoader()
    }
  }

  const emailLogin = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !password) {
      toast.error("Please fill out both fields.", {
        position: "top-center",
        transition: Bounce,
      });
      return;
    }

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.", {
        position: "top-center",
        transition: Bounce,
      });
      return;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters long.", {
        position: "top-center",
        transition: Bounce,
      });
      return;
    }

    try {
      const form = {
        type: 'selflogin',
        password: password,
        email: email
      };
      const apiResponse = await createSocialAccount(form);
      if (apiResponse.returnValue.error) {
        toast.error(apiResponse.returnValue.error, {
          position: "top-center",
          transition: Bounce,
        });
        return;
      }
      if (apiResponse.returnValue) {
        const data = {
          type: 'self',
          name: apiResponse.returnValue.username,
          userID: apiResponse.returnValue.social_id,
          wallet: apiResponse.returnValue
        };
        if (apiResponse.returnValue.wallet.user_id) {
          await clearStorage();
          localStorage.setItem('user', JSON.stringify(data));
          localStorage.setItem('access_token', apiResponse.returnValue.token);
          const responseSettings = await getGeneralSettings();
          if (responseSettings) {
            localStorage.setItem('timeZone', responseSettings.time_zone);
          }
          history("/home");
        } else {
          await clearStorage();
          localStorage.setItem('user', JSON.stringify(data));
          localStorage.setItem('access_token', apiResponse.returnValue.token);
          history("/signup");
        }
      }


    } catch (error) {
      console.error("Login failed:", error);
    }
  }

  return (
    <div className='d-flex justify-content-center align-items-center min-vh-80'>
      <div className='col-10 col-md-8 col-lg-6 login-section'>
        <div className='row flex-column flex-lg-row'>
          {/* Left section for logo and text */}
          <div className='col-12 col-lg-6 d-flex flex-column align-items-center justify-content-center mb-4 mb-lg-0'>
            <img src={logo} alt='logo' width="88" height="70" />
            <p className='x-bold'>Login</p>
            <p className='s-gray-text position-relative text-truncate'>Enter your email to login</p>
          </div>
          {/* Right section for inputs and buttons */}
          <div className='col-12 col-lg-6 d-flex flex-column align-items-center justify-content-center'>
            <input className='email-input mt-4' type='email' placeholder='Your E-mail' value={email} onChange={(e) => setEmail(e.target.value)} />
            <input className='password-input mt-4' type='password' placeholder='Your Password' value={password} onChange={(e) => {
              let value = e.target.value.trim();
              setPassword(value);
            }} />
            <button className='otp-btn mt-4' onClick={async () => {
              await emailLogin();
            }}><span className='otp-text'>Login</span></button>

            <div className='social-border-section mt-4'>
              <span className='border-line'></span>
              <span className='continue-text'>Or Continue With</span>
              <span className='border-line'></span>
            </div>

            <div className='social-section d-flex justify-space-between mt-4'>
              <span className='google cursor-pointer social-text flex-fill text-center'   onClick={async () => { // Keep async here if login() needs it, but often it doesn't
              try {
                showLoader(); 
                login();
              } catch (error) {
                console.error("Google login initiation error:", error);
                toast.error("Could not start Google login.", { position: "top-center", transition: Bounce });
                hideLoader(); 
              }
             
            }}>{social_svg.google_svg} Google</span>
              {/* <span className='apple cursor-pointer social-text'>{social_svg.apple_svg} Apple</span> */}
              <span className='facebook cursor-pointer flex-fill text-center'>
                <FacebookLogin
                  appId={config.FACEBOOK_APP_ID}
                  autoLoad={false}
                  fields="name,email,picture"
                  callback={handleFacebookCallback}
                  render={renderProps => (
                    <span className='social-text' onClick={() => {
                        try {
                            showLoader();
                            renderProps.onClick();
                        } catch (error) {
                          
                            console.error("Error initiating Facebook login:", error);
                            toast.error("Could not start Facebook login.", { position: "top-center", transition: Bounce });
                            hideLoader();
                        }
                    }}>
                        {social_svg.facebook_svg} Facebook
                    </span>
                )}
                />
              </span>
            </div>

            <div className='mt-4'>
              <div className='continue-text gradient-text cursor-pointer text-center fw-bold' onClick={() => history("/forgot")}>
                Forgot password?
              </div>
              <span className='continue-text'>Don’t have an account? </span>
              <span className='continue-text gradient-text cursor-pointer fw-bold' onClick={() => history("/create")}>
                Create account
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
}

export default App;
